import { Translate } from 'src/app/helpers/global-functions'
export class Translator{
    translate = (textEn:string,textKh:string) => {
        return Translate(textEn,textKh)
    }
}